<template>
  <div class="app-container">
    <el-tabs v-model="activeName" style="padding-left: 5px;">
      <el-tab-pane label="订单" name="one" style="">
        <order v-if="activeName=='one'"></order>
      </el-tab-pane>
      <!-- <el-tab-pane label="付款风控反馈" name="three">
        <fengkongfankui v-if="activeName=='three'"></fengkongfankui>
      </el-tab-pane> -->
      <el-tab-pane label="运单" name="two">
        <way v-if="activeName=='two'"></way>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import order from '@/views/newTMS/transportation/recycleBin/order.vue'
import way from '@/views/newTMS/transportation/recycleBin/way.vue'
export default {
  components: {
    order,
    way
  },
  data () {
    return {
      activeName: 'one'
    }
  },
  created () {

  }
}
</script>
<style scoped lang='less'>
/deep/.el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
    background-color: #0c46a2 !important;
    color: #fff;
}
/deep/.el-tabs__header{
  margin-bottom: 0;
}
</style>
